__turbopack_context__.v({
  "activeIndicator": "ContentViewerNavigation-module__ZxcwLa__activeIndicator",
  "alwaysVisible": "ContentViewerNavigation-module__ZxcwLa__alwaysVisible",
  "hoverZone": "ContentViewerNavigation-module__ZxcwLa__hoverZone",
  "hovering": "ContentViewerNavigation-module__ZxcwLa__hovering",
  "navLine": "ContentViewerNavigation-module__ZxcwLa__navLine",
  "navLineContainer": "ContentViewerNavigation-module__ZxcwLa__navLineContainer",
  "navSquare": "ContentViewerNavigation-module__ZxcwLa__navSquare",
  "navSquareBottom": "ContentViewerNavigation-module__ZxcwLa__navSquareBottom",
  "navSquareTooltip": "ContentViewerNavigation-module__ZxcwLa__navSquareTooltip",
  "navSquareTop": "ContentViewerNavigation-module__ZxcwLa__navSquareTop",
  "navigation": "ContentViewerNavigation-module__ZxcwLa__navigation",
  "progressFill": "ContentViewerNavigation-module__ZxcwLa__progressFill",
  "segment": "ContentViewerNavigation-module__ZxcwLa__segment",
  "segmentActive": "ContentViewerNavigation-module__ZxcwLa__segmentActive",
  "segmentIndicator": "ContentViewerNavigation-module__ZxcwLa__segmentIndicator",
  "segmentPassed": "ContentViewerNavigation-module__ZxcwLa__segmentPassed",
  "segmentTooltip": "ContentViewerNavigation-module__ZxcwLa__segmentTooltip",
  "trackBackground": "ContentViewerNavigation-module__ZxcwLa__trackBackground",
  "visible": "ContentViewerNavigation-module__ZxcwLa__visible",
});
